import React, {useEffect} from 'react'

const Weathercard = ({ tempInfo }) => {

    const [weatherState, setWeatherState] = React.useState("");

    const {temp, humidity, pressure,feels_like, weathermood, name, speed, country}= tempInfo;

    useEffect(() => {
        if(weathermood){
            switch (weathermood) {
                case "Clouds": setWeatherState("wi-cloudy");
                     break;
                case "Haze": setWeatherState("wi-fog");
                    break;
                case "Fog": setWeatherState("wi-fog");
                    break;
                case "Clear": setWeatherState("wi-alien");
                    break;
                case "Rain": setWeatherState("wi-rain");
                    break;
                case "Snow": setWeatherState("wi-snowflake-cold");
                    break;
                case "Smoke": setWeatherState("wi-smoke");
                    break;
                case "Tornado": setWeatherState("wi-tornado");
                    break;
                case "Thunderstorm": setWeatherState("wi-thunderstorm");
                    break;
                case "Drizzle": setWeatherState("wi-showers");
                    break;
                case "Mist": setWeatherState("wi-fog");
                    break;
                case "Dust": setWeatherState("wi-dust");
                    break;
                case "Sand": setWeatherState("wi-sandstorm");
                    break;
                case "Squall": setWeatherState("wi-sandstorm");
                    break;
                case "Ash": setWeatherState("wi-volcano");
                    break;
            
                default:
                    setWeatherState("wi-alien");
                    break;
            }
        }
    }, [weathermood]);
    


    return (
        <>
            <article className='widget'>
                <div className="weatherIcon">
                    <i className={`wi ${weatherState}`}></i>
                </div>

                <div className='weatherInfo'>
                    <div className='temperature'>
                        <span>{temp}°C</span>
                    </div>
                    <div className='description'>
                        <div className='weatherCondition'>{weathermood}</div>
                        <div className="place">{name}, {country}</div>
                    </div>
                </div>

                <div className="date"> {new Date().toLocaleString()} </div>

                {/* our 4 column section */}
                <div className='extra-temp'>
                    <div className='temp-info-minmax'>
                        <div className='two-sided-section'>
                            <p><i className={"wi wi-thermometer"}></i></p>
                            <p className="extra-info-leftside">
                                {feels_like}°C <br />
                                Feels Like
                            </p>
                        </div>

                        <div className='two-sided-section'>
                            <p><i className={"wi wi-humidity"}></i></p>
                            <p className="extra-info-leftside">
                                {humidity}% <br />
                                Humidity
                            </p>
                        </div>
                    </div>

                    <div className="weather-extra-info">
                        <div className='two-sided-section'>
                            <p><i className={"wi wi-rain"}></i></p>
                            <p className="extra-info-leftside">
                                {pressure} mBar <br />
                                Pressure

                            </p>
                        </div>

                        <div className='two-sided-section'>
                            <p><i className={"wi wi-strong-wind"}></i></p>
                            <p className="extra-info-leftside">
                                {speed} Km/h<br />
                                Wind
                            </p>
                        </div>

                    </div>
                </div>

            </article>
        </>
    );
};

export default Weathercard;


